module.exports = __webpack_public_path__ + "img/gamestage.d16572a2.png";